exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".subscribe-box{-ms-flex-item-align:start;align-self:flex-start}.subscribe-box .checkbox-box{margin-left:-15px}.subscribe-box .checkbox-box label:first-child{display:none}.subscribe-box .checkbox-box label:after{content:\"\"}.subscribe-box .checkbox-box .checkbox--label{margin-top:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/subscribe/subscribe.styl
// module id = 66
// module chunks = 0 1